module.exports = __webpack_public_path__ + "img/invoices.c12588ba.svg";